import { colours, sizes } from '@qflow/theme'
import { Flag } from 'portal/lib/primitives/icons'

export function InfractionFlag() {
  return <Flag colour={colours.ERROR} size={sizes.MEDIUM} />
}
